<template>
  <div>
    <v-container>
      <div
        class="grey lighten-4 py-2  d-flex flex-wrap align-center font-medium"
        :class="$store.state.mobile ? '' : 'pe-4 ps-5'"
      >
        <div
          v-if="$route.query.categoryName"
          class="text-h5 font-medium me-8 ps-3"
        >
          {{ $store.getters.languageGetter === '1' ? $route.query.categoryName : $route.query.categoryNameEn }}
        </div>
        <v-btn
          text
          small
          class="text-capitalize body-1"
          :class="bestMatch ? 'font-medium' : ''"
          @click="minPrice='';maxPrice='';resetSort();loadPageData();"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            افضل مباراة
          </template>
          <template v-else>
            Best Match
          </template>
        </v-btn>
        <v-btn
          text
          small
          class="text-capitalize body-1 "
          :class="saleIndex ? 'font-medium' : ''"
          @click="sortGoodsBy('saleIndex')"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            أوامر
          </template>
          <template v-else>
            Orders
          </template>
          <v-icon
            size="14px"
            color="#666"
            class="ms-1 flip-reverse"
            :class="saleIndex === '1' ? 'reverse' : ''"
          >
            mdi-arrow-down
          </v-icon>
        </v-btn>
        <v-btn
          text
          small
          class="text-capitalize body-1 "
          :class="timeIndex ? 'font-medium' : ''"
          @click="sortGoodsBy('timeIndex')"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            جديد
          </template>
          <template v-else>
            New
          </template>
          <v-icon
            size="14px"
            color="#666"
            class="ms-1 flip-reverse"
            :class="timeIndex === '1' ? 'reverse' : ''"
          >
            mdi-arrow-down
          </v-icon>
        </v-btn>
      </div>
      <div
        v-if="$route.query.searchStr"
        class="px-2 pt-4"
      >
        <v-chip
          close
          @click:close="$router.replace({name: 'GoodsList', query: {categoryId: $route.query.categoryId, categoryName: $route.query.categoryName, categoryNameEn: $route.query.categoryNameEn, p: 1}})"
        >
          {{ $route.query.searchStr }}
        </v-chip>
      </div>
    </v-container>
    <v-row
      v-if="loading"
      class="text-center px-4"
    >
      <v-col
        v-for="i in 20"
        :key="i"
        :cols="$store.state.mobile ? 6 : 3"
      >
        <div :class="$store.state.mobile ? '' : 'px-4'">
          <v-skeleton-loader
            type="image"
          />
          <div class="px-12">
            <v-skeleton-loader
              type="list-item"
            />
          </div>
          <v-skeleton-loader
            type="heading"
            class="mx-auto"
          />
        </div>
      </v-col>
    </v-row>
    <div v-else>
      <v-container
        class="pt-0"
      >
        <v-row
          class="text-center"
        >
          <v-col
            v-for="item in goodsListLocal.data"
            :key="item.id"
            :cols="$store.state.mobile ? 6 : 3"
          >
            <div
              class="py-3"
              :class="$store.state.mobile ? '' : 'px-1'"
            >
              <v-card
                elevation="0"
                tile
              >
                <router-link
                  :to="{name: 'GoodsDetail', params: {id: item.id}}"
                >
                  <v-img
                    aspect-ratio="1"
                    contain
                    :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                    class="grey lighten-5"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </router-link>
              </v-card>
              <div class="px-4">
                <div class="text-h6 mt-2 line-break line-height-sm">
                  <router-link
                    :to="{name: 'GoodsDetail', params: {id: item.id}}"
                  >
                    {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                  </router-link>
                </div>
                <div
                  v-if="$store.state.usedCountry"
                  class="black--text d-flex align-center justify-center"
                >
                  <span
                    class="text-h4 me-2"
                  >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                  <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-center">
              <v-pagination
                :value="+$route.query.p"
                page-aria-label="Page"
                previous-aria-label="PrevPage"
                next-aria-label="NextPage"
                wrapper-aria-label="Pagination"
                current-page-aria-label="CurrentPage"
                :length="length"
                :total-visible="7"
                @input="changePagination"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div
        v-if="!goodsListLocal.data.length"
        class="grey--text py-4 text-center"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          لا يوجد شيء هنا
        </template>
        <template v-else>
          There is nothing here
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'GoodsList',
  components: {
  },
  data() {
    return {
      loading: false,
      bestMatch: true,
      orderIndex: '',
      saleIndex: '',
      timeIndex: '',
      minPrice: '',
      maxPrice: '',
    };
  },
  computed: {
    ...mapState('goods', ['goodsList']),
    ...mapState(['tagGoods']),
    length() {
      return Math.ceil((this.goodsListLocal.totalItem ? +this.goodsListLocal.totalItem : 1) / process.env.VUE_APP_PAGESIZE);
    },
    goodsListLocal() {
      return this.$route.query.type ? this.tagGoods[this.$route.query.target] : this.goodsList;
    },
    // sort: orderIndex 1：价格升序 2：价格降序  saleIndex 1: 销量升序 2：销量降序
    params() {
      return {
        p: this.$route.query.p,
        name: this.$route.query.target,
        type: this.$route.query.type,
        categoryId: this.$route.query.categoryId,
        searchStr: this.$route.query.searchStr,
        orderIndex: this.orderIndex,
        saleIndex: this.saleIndex,
        timeIndex: this.timeIndex,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        pageSize: process.env.VUE_APP_PAGESIZE,
      };
    },
  },
  watch: {
    $route() {
      this.page = +this.goodsListLocal.currentPage;
      this.loadPageData();
    },
  },
  created() {
    this.loadPageData();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.searchStr || to.query.categoryId || to.query.categoryName || from.query.searchStr || from.query.categoryId || from.query.categoryName) {
      this.$store.commit('goods/RESET_GOODS_LIST');
    }
    next();
  },
  methods: {
    ...mapActions(['getGoodsByTagAsync']),
    ...mapActions('goods', ['getGoodsListAsync']),
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
    loadPageData() {
      this.loading = true;
      if (this.$route.query.type) {
        this.getGoodsByTagAsync(this.params).then(() => {
          this.page = +this.goodsListLocal.currentPage;
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.getGoodsListAsync(this.params).then(() => {
          this.page = +this.goodsListLocal.currentPage;
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    sortGoodsBy(target) {
      this.$store.commit('goods/RESET_GOODS_LIST');
      if (target === 'saleIndex') {
        this.orderIndex = '';
        this.timeIndex = '';
      } else if (target === 'orderIndex') {
        this.saleIndex = '';
        this.timeIndex = '';
      } else {
        this.orderIndex = '';
        this.saleIndex = '';
      }
      if (this[target] === '1') {
        this[target] = '2';
      } else {
        this[target] = '1';
      }
      this.bestMatch = false;
      this.loadPageData();
    },
    resetSort() {
      this.orderIndex = '';
      this.saleIndex = '';
      this.timeIndex = '';
      this.bestMatch = true;
      this.$store.commit('goods/RESET_GOODS_LIST');
    },
    searchByPrice() {
      this.resetSort();
      this.loadPageData();
    },
    changePagination(v) {
      this.$router.replace({
        name: 'GoodsList',
        query: {
          ...this.$route.query,
          p: v,
        },
      });
      this.loadPageData();
    },
  },
};
</script>

<style lang="scss">

</style>
